// public/js/features/devices/components/device-action-menu.js
import { positionDropdown } from '../../../modules/ui.js';
import { can, getCurrentUser } from '../../../modules/rbac.js';

export function showActionMenu(e, device, refreshCallback) {
  const isAssigned = !!device.assetId;
  const groups = getCurrentUser().groups || [];
  const mayAssign = can(groups, 'assignDevice');
  const mayDelete = can(groups, 'deleteDevice');

  // Only offer actions the caller can actually perform (the server is still
  // authoritative). A power viewer / operator may pair, but not delete.
  const items = [];
  if (mayAssign) {
    items.push(isAssigned
      ? `<a class="dropdown-item text-warning unassign-device" href="#">🔓 Unassign from ${device.assetId}</a>`
      : `<a class="dropdown-item assign-asset" href="#">🔗 Assign Asset</a>`);
  }
  if (mayDelete) {
    if (items.length) items.push('<div class="dropdown-divider"></div>');
    items.push('<a class="dropdown-item text-danger delete-device" href="#">🗑️ Delete Device</a>');
  }
  if (!items.length) items.push('<span class="dropdown-item-text text-muted small">No actions available</span>');

  const menuHTML = `
    <div class="dropdown-menu show shadow" style="position:absolute; min-width:220px; z-index:1050;">
      ${items.join('')}
    </div>`;

  const menu = document.createElement('div');
  menu.innerHTML = menuHTML;
  const dropdown = menu.firstElementChild;
  document.body.appendChild(dropdown);

  positionDropdown(dropdown, e.target, 220);

  const closeMenu = () => {
    if (dropdown && dropdown.parentNode) dropdown.parentNode.removeChild(dropdown);
  };
  setTimeout(() => document.addEventListener('click', closeMenu, { once: true }), 10);

  // === ASSIGN ASSET — with retry to avoid a race condition ===
  if (mayAssign && !isAssigned) {
    dropdown.querySelector('.assign-asset').addEventListener('click', async (ev) => {
      ev.preventDefault();
      closeMenu();

      let attempts = 0;
      const maxAttempts = 8;

      const tryOpenModal = () => {
        if (typeof window.openAssignDeviceModal === 'function') {
          window.openAssignDeviceModal(device, refreshCallback);
          return true;
        }
        return false;
      };

      while (attempts < maxAttempts) {
        if (tryOpenModal()) return;
        attempts++;
        await new Promise(r => setTimeout(r, 80)); // short retry
      }

      window.showToast('Modal is still loading – please try again in 1 second', 'warning');
    });
  }

  // Unassign (UI placeholder)
  if (mayAssign && isAssigned) {
    dropdown.querySelector('.unassign-device').addEventListener('click', async (ev) => {
      ev.preventDefault();
      closeMenu();
      if (confirm(`Unassign device ${device.deviceId} from asset ${device.assetId}?`)) {
        window.showToast('Unassign coming soon (backend stub)', 'info');
        if (refreshCallback) await refreshCallback();
      }
    });
  }

  // Delete
  if (mayDelete) {
    dropdown.querySelector('.delete-device').addEventListener('click', async (ev) => {
      ev.preventDefault();
      closeMenu();
      if (confirm(`Delete device ${device.deviceId} permanently?`)) {
        try {
          await window.authenticatedFetch(`api/v1/devices/${encodeURIComponent(device.deviceId)}`, { method: 'DELETE' });
          window.showToast('Device deleted successfully', 'success');
          if (refreshCallback) await refreshCallback();
        } catch (err) {
          window.showToast('Delete failed', 'danger');
        }
      }
    });
  }
}